// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"317":"7dea909a","414":"aaaf81fd","920":"ff049010","2491":"e034fe34","2589":"32fc1245","5131":"f1cd919b","7933":"4b936f6e"}[chunkId] + ".css";
};